import React from 'react';
import {
  Accordion,
  AccordionDetails as MuiExpansionPanelDetails,
  AccordionSummary as MuiExpansionPanelSummary,
  withStyles,
} from '@material-ui/core';
import { ExpandMore as MuiExpandMoreIcon } from '@material-ui/icons';
import { isRtl } from 'modules/language/selectors/language';

import theme from './FilterItem.scss';


const ExpandMoreIcon = withStyles({
  root: {
    marginRight: isRtl() ? -12 : 'auto',
    marginLeft: isRtl() ? -12 : 'auto',
  },
})(MuiExpandMoreIcon);

const ExpansionPanelDetails = withStyles({
  root: {
    padding: '10px 15px',
  },
})(MuiExpansionPanelDetails);

const ExpansionPanelSummary = withStyles({
  root: {
    overflow: 'hidden',
  },
})(MuiExpansionPanelSummary);

const FilterItem = ({ expanded, onChange, label, description, children }) => (
  <Accordion
    square
    expanded={ expanded }
    onChange={ onChange }
  >
    <ExpansionPanelSummary expandIcon={ <ExpandMoreIcon /> } >
      <span>{ label }</span>
      <span className={ theme.selectedFilterDescription }>{ description }</span>
    </ExpansionPanelSummary>
    <ExpansionPanelDetails>
      { children }
    </ExpansionPanelDetails>
  </Accordion>
);

export default FilterItem;
